module.exports = __webpack_public_path__ + "img/section7-1.800f4850.svg";